import React, { useState } from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import { Fade } from 'react-slideshow-image';
import { Image } from './Image';
import { theme, media, color } from '../theme';
import { vr } from '../utils';
import { HorizontalNewsBar, navHorizontalMargin, navVerticalOffset } from './HorizontalNewsBar';

const opacity = 0.2;

export function Slideshow({ images, isPreviewMode }) {
  const [ activeIndex, setActiveIndex ] = useState(0);

  return (
    <Hero>
      { (Array.isArray(images) && images.length > 0) && (
        <>
          <Slider onChange={(oldIndex, newIndex) => setActiveIndex(newIndex)}>
            {images.map(({ title, desc, link, image }, index) => (
              <Link to={link} className="each-fade" tabIndex={index === activeIndex ? 0 : -1}>
                <Image
                  src={image}
                  breakpoints={[
                    { width: 300 },
                    { width: 400 },
                    { width: 500 },
                    { width: 600 },
                    { width: 768 },
                    { width: 940 },
                    { width: 1024 },
                    { width: 1200 },
                    { width: 1400 },
                    { width: 1800 },
                  ]}
                  sizes="100vw"
                  applyCloudinary
                  style={{ height: 'inherit' }}
                />
                <div className="section">
                  <div className="container">
                    <h2 data-font="display">{title}</h2>
                    <p>{desc}</p>
                  </div>
                </div>
              </Link>
            ))}
          </Slider>
          {/* <Sidebar>
            {images.map(({ title, desc, link, image }, index) => (
              <li>
                <a href="#">
                  <h3 data-font="condensed">{title}</h3>
                </a>
              </li>
            ))}
          </Sidebar> */}
          {/* <Nav>
            {images.map(({ title, desc, link, image }, index) => (
              <li>
                <a href={link}>{title}</a>
              </li>
            ))}
          </Nav> */}
          {!isPreviewMode && (
            <HorizontalNewsBar />
          )}
        </>
      )}
    </Hero>
  );
}

const Hero = styled.div`
  height: 300px;
  position: relative;
  background: ${color.black};

  .nav.container {
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, ${navVerticalOffset});
    z-index: 10;
    height: auto;
  }

  @media ${media.landscapeS} {
    height: 400px;
  }

  @media ${media.landscapeM} {
    height: 450px;
  }

  @media ${media.tabletL} {
    height: calc(100vh - 250px - ${theme.headerContainerHeight});
  }

  .gatsby-image-wrapper {
    height: inherit;
  }

  * {
    height: inherit;
  }

  a {
    color: ${color.white};

    &:focus {
      color: ${color.lightgray};
    }
  }

  .section {
    position: absolute;
    z-index: 80;
    left: 50vw;
    width: 100vw;
    width: calc(100vw - ${theme.containerPadding} * 2);
    color: inherit;
    height: auto;
    max-width: ${theme.maxWidth};
    transform: translate(-50%, 0);
    bottom: 30px;

    @media ${media.landscapeL} {
      bottom: ${vr(2)};

      .container * {
        padding-left: ${navHorizontalMargin};
      }
    }
    
    h2 {
      display: block;
      color: inherit;
      height: auto;

      @media ${media.desktopS} {
        font-size: 1.8rem;
      }
    }
    
    p {
      color: #fff;
      color: inherit;
      display: none;
      margin-bottom: 0;
      margin-top: 0.5rem;

      @media ${media.landscapeL} {
        display: block;
      }

      @media ${media.desktopS} {
        width: 80%;
      }
    }
  }
`;

// const Sidebar = styled.ul`
//   width: 250px;
//   position: absolute;
//   margin: 0;
//   padding: 0;
//   list-style: none;
//   z-index: 100;
//   left: 0;
//   top: 0;
//   bottom: 0;
//   display: flex;
//   flex-direction: column;
//   /* border-right: ${color.brown} 1px solid;
//   border-left: ${color.brown} 1px solid; */
//   /* box-shadow: ${theme.containerShadow}; */

//   li {
//     height: auto;
//     margin: 0;
//     padding: 0;
//     flex-grow: 1;
//     display: flex;
//     flex-direction: column;

//     a {
//       flex-grow: 1;
//       display: flex;
//       align-items: center;
//       padding-left: ${theme.containerPadding};
//       /* border-bottom: ${color.brown} 1px solid; */
//       /* background: linear-gradient(
//         ${Color(color.darkbrown).alpha(0.80)},
//         ${Color(color.darkbrown).alpha(0.90)}
//       ); */
//       background: ${Color(color.cream).alpha(0.9)};
//       text-decoration: none;
//       color: ${color.brown};

//       h3 {
//         color: inherit;
//         font-size: 0.9rem;
//       }

//       &:hover {
//         background: green;
//       }
//     }

//     &:last-child a {
//       border-bottom: 0;
//     }
//   }
// `;

const Slider = styled(Fade)`
  position: relative;
  width: 100%;

  .react-slideshow-container {
    display: flex;
    align-items: center;

    .nav {
      height: 30px;
      background: rgba(255, 255, 255, 0.6);
      width: 30px;
      z-index: 10;
      text-align: center;
      cursor: pointer;
      color: #fff;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      display: none;

      span {
        display: block;
        width: 10px;
        height: 10px;
        border-color: #000;
        border-style: solid;
        transform: rotate(45deg)
      }

      &.disabled {
        span {
          border-color: #666
        }

        &:hover {
          cursor: not-allowed
        }
      }

      &:hover {
        background: white;
        color: #666
      }

      &:first-of-type {
        margin-right: -30px;
        border-right: 0;
        border-top: 0;

        span {
          margin-left: 5px;
          border-right: 0;
          border-top: 0
        }
      }

      &:last-of-type {
        margin-left: -30px
      }
    }

    .custom-nav {
      z-index: 10;

      span {
        margin-right: 5px;
        border-left: 0;
        border-bottom: 0
      }
    }

    & + div.indicators {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin-top: 20px;

      & > .each-slideshow-indicator {
        width: 7px;
        height: 7px;
        margin: 0 5px 10px;
        border-radius: 50%;
        background: #ccc;
        cursor: pointer;

        &:hover {
          background: #666
        }

        &.active {
          background: #000
        }
      }
    }
  }

  .react-slideshow-fade-wrapper {
    width: 100%;
    overflow: hidden;

    .react-slideshow-fade-images-wrap {
      display: flex;
      flex-wrap: wrap;

      > div {
        position: relative;
        opacity: 0;
        
        &:after {
          content: "";
          display: block;
          background-color: rgba(0,0,0,${opacity});
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
        }
      }
    }
  }

  .react-slideshow-wrapper {
  
    .slide {
      width: 100%;
      overflow: hidden
    }
    
    .images-wrap {
      display: flex;
      flex-wrap: wrap
    }
  }

  a {
    display: block;
  }

  .react-slideshow-zoom-wrapper {
    width: 100%;
    overflow: hidden;

    .zoom-wrapper {
      display: flex;
      flex-wrap: wrap;
      overflow: hidden;

      > div {
        position: relative;
        display: flex
      }
    }
  }
`;
